import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import GuideStar from '../assets/images/GuideStar.png';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaYoutube } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import { useForm } from '../hooks/useForm';
import { useHistory } from 'react-router-dom';
import logo from '../assets/images/logo.jpg';
import ReCAPTCHA from 'react-google-recaptcha';
import charityNavigator from '../assets/images/Four-Star Rating Badge - Full Color.png';
import charityWatch from '../assets/images/CharityWatch_Seal_RGB_WEB_hi-res.png';
import bbb from '../assets/images/bbb-bw.png';
import bia from '../assets/images/BIA_seal_500x828.webp';
import { FaXTwitter } from "react-icons/fa6";
const Footer: React.FunctionComponent = () => {
  const Initial = {
    email: '',
    first_name: '',
    last_name: '',
  };
  const history = useHistory();
  const { Values, setValues, handleChange, resetForm } = useForm(Initial);
  const { first_name, last_name, email } = Values;
  const recaptchaRef = React.createRef<ReCAPTCHA>();
const FOOTER_LINKS = [
  {
    href: `${process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL}/learn-about-rainn/contact-us/`,
    text: 'Contact Us',
  },
  {
    href: `${process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL}/learn-about-rainn/careers-at-rainn/`,
    text: 'Careers',
  },
  {
    href: `${process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL}/learn-about-rainn/privacy-policy/`,
    text: 'Privacy Policy',
  },
  {
    href: `${process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL}/learn-about-rainn/rainn-terms-of-service/`,
    text: 'Terms of Service',
  },
];
const SOCIAL_LINKS = [
  { href: 'https://www.instagram.com/rainn/', icon: FaInstagram },
  { href: 'https://www.facebook.com/RAINN01/', icon: FaFacebookF },
  { href: 'https://www.tiktok.com/@rainn', icon: SiTiktok },
  { href: 'https://www.linkedin.com/company/rainn', icon: FaLinkedinIn },
  { href: 'https://x.com/RAINN', icon: FaXTwitter },
  { href: 'https://www.youtube.com/@RAINN01', icon: FaYoutube },
];

const COPYRIGHT_LINKS = [
  { href: '', src: bbb, alt: 'BBB' },
  { href: '', src: charityWatch, alt: 'Charity Watch' },
  { href: '', src: charityNavigator, alt: 'Charity Navigator' },
  { href: '', src: bia, alt: 'Charity Navigator' },
  {
    href: `${process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL}/learn-about-rainn/federal-funding-disclosure/`,
    text: 'Federal Funding Disclaimer',
  },
  {
    href: `${process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL}/legal-disclosures/`,
    text: 'Legal Disclosures',
  },
  {
    href: `${process.env.REACT_APP_HEADER_NAVIGATION_BASE_URL}/our-impact/financials/`,
    text: 'Financials',
  },
];

  return (
    <div className=" helproom-footer">
      <div className="footer-bg">
        <div className="grid">
          <div className="footer-header ">
            <div className="left-container">
              <List className="footer-links p-0">
                {FOOTER_LINKS.map((link, index) => (
                  <ListItem key={index}>
                    <Link href={link.href}>{link.text}</Link>
                  </ListItem>
                ))}
              </List>
            </div>
            <div className="right-container">
              <List className="flex p-0 social-icons">
                 {SOCIAL_LINKS.map((social, index) => {
                  const IconComponent = social.icon;
                  return (
                    <ListItem key={index} disableGutters>
                      <Link href={social.href}>
                        <IconComponent className=" text-lg social-icon" />
                      </Link>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          </div>
          <div className="footer-form-container">
            <div className="left-container ">
              <div className="hotline-logo font-interbold text-6xl text-pc-1">
                <img
                  className="w-24 md:h-full md:w-32"
                  src={logo}
                  alt="Rainn Logo"
                />
              </div>
              <Typography component="p" className="font-bold text-lg  my-6 ">
                Get RAINN updates
              </Typography>
              <form
                name="emailNewsletter"
                id="emailNewsletter"
                action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
                method="POST"
                className="grid grid-cols-2 lg:gap-4 gap-2 footer-form items-start"
              >
                <input
                  type="hidden"
                  name="captcha_settings"
                  value='{"keyname":"RAINN_org_Newsletter","fallback":"true","orgId":"00D700000008OJ2","ts":""}'
                />
                <input name="oid" type="hidden" value="00D700000008OJ2" />
                <input
                  type="hidden"
                  name="retURL"
                  value="https://rainn.org/thank-you-newsletter"
                />
                <input
                  type="hidden"
                  name="Campaign_ID"
                  value="70170000000KLBL"
                />
                <input
                  type="hidden"
                  name="recordType"
                  value="012390000005yYP"
                />
                <input
                  type="hidden"
                  name="URL"
                  value="https://centers-staging.rainn.org/"
                />
                <input
                  type="hidden"
                  name="00N39000003V1iR"
                  value="https://www.rainn.org/thank-you"
                />
                <TextField
                  className="input-footer"
                  id="first_name"
                  name="first_name"
                  value={first_name}
                  onChange={handleChange}
                  placeholder="First Name"
                  fullWidth
                />
                <TextField
                  className="input-footer"
                  onChange={handleChange}
                  value={last_name}
                  name="last_name"
                  placeholder="Last Name"
                  id="last_name"
                  fullWidth
                />
                <TextField
                  className="input-footer with-button"
                  placeholder="Email Address"
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  fullWidth
                />
                <div className="hidden">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={process.env.React_App_Site_Key as string}
                    size="invisible"
                    badge="bottomright"
                  />
                </div>
                <Button className=" button-footer-signup h-full" type="submit">
                  Sign Up
                </Button>
              </form>
            </div>
            <div className="lg:col-span-2 col-span-12 flex justify-center items-end">
              <img
                src={GuideStar}
                className=""
                alt="Guidestar paltinum transparency logo"
              />
            </div>
            <div className="right-container ">
              <div className="footer-callout">
                <div className="grid-container">
                  <Typography component="h6" className="text-xl font-bold">
                  RAINN National Sexual Assault Hotline
                  </Typography>
                  <Typography
                    component="h6"
                    className="text-center  font-notosans"
                  >
              
                    Trained support specialists provide confidential, 24/7 support in English and Spanish.
                  </Typography>
                  
                  <Link href="https://rainn.org/help-and-healing/hotline/">
                    <Button className="button-footer-signup m-auto">
                      Get Help Now
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-links">
          <List className="flex ">
            {COPYRIGHT_LINKS.map((item, index) => (
              <ListItem key={index} disableGutters>
               {item.href  ?
               <Link href={item.href}>{item.src ? <img className="w-8 md:h-full md:w-9" src={item.src} alt={item.alt} /> : item.text}</Link>:
                item.src ? <img className="w-8 md:h-full md:w-9" src={item.src} alt={item.alt} /> : item.text}
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    </div>
  );
};

export default Footer;
